import _createClass from "/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _callSuper from "/app/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "/app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.array.concat.js";
import { __decorate } from "tslib";
import NumberAnimation from '@/components/numberAnimation/NumberAnimation.vue';
import { Vue, Options } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
var TotalSummariesItem = /*#__PURE__*/function (_Vue) {
  function TotalSummariesItem() {
    var _this;
    _classCallCheck(this, TotalSummariesItem);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, TotalSummariesItem, [].concat(args));
    _defineProperty(_this, "title", void 0);
    _defineProperty(_this, "total", void 0);
    _defineProperty(_this, "totalPercentage", void 0);
    return _this;
  }
  _inherits(TotalSummariesItem, _Vue);
  return _createClass(TotalSummariesItem);
}(Vue);
__decorate([Prop({
  default: ''
})], TotalSummariesItem.prototype, "title", void 0);
__decorate([Prop()], TotalSummariesItem.prototype, "total", void 0);
__decorate([Prop()], TotalSummariesItem.prototype, "totalPercentage", void 0);
TotalSummariesItem = __decorate([Options({
  components: {
    NumberAnimation: NumberAnimation
  }
})], TotalSummariesItem);
export default TotalSummariesItem;